import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRouteParams } from '../../../infrastructure/hooks/use-route-params';
import { getBlueprintsNavigationLinks } from '../../../constants/navigation.constants';
import { Navigation } from '../../_events/_manage-event/shared/navigation/navigation';

export const BlueprintsNavigation = (): JSX.Element => {
    const { accountId } = useRouteParams();

    const intl = useIntl();
    const links = getBlueprintsNavigationLinks(accountId, intl);

    return <Navigation links={links} />;
};
